import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const categories = [
    { id: 1, name: 'اللحوم والدواجن', icon: 'ri-restaurant-fill', color: 'bg-red-100' },
    { id: 2, name: 'الخضروات والفواكه', icon: 'ri-leaf-fill', color: 'bg-green-100' },
    { id: 3, name: 'المخبوزات', icon: 'ri-cake-3-fill', color: 'bg-yellow-100' },
    { id: 4, name: 'الأجبان والألبان', icon: 'ri-cup-fill', color: 'bg-blue-100' },
    { id: 5, name: 'العصائر والمشروبات', icon: 'ri-drink-2-fill', color: 'bg-purple-100' },
    { id: 6, name: 'المعلبات', icon: 'ri-archive-fill', color: 'bg-orange-100' }
  ];

  const nearbyStores = [
    {
      id: 1,
      name: 'بقالة الأمانة',
      distance: '0.5 كم',
      rating: 4.8,
      image: 'https://public.readdy.ai/ai/img_res/e5a3ecd7d33ec3d6b8ba7bee09e8291f.jpg'
    },
    {
      id: 2,
      name: 'سوبر ماركت النخيل',
      distance: '0.8 كم',
      rating: 4.6,
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Saudi%20grocery%20store%20with%20palm%20trees%2C%20clean%20modern%20storefront%2C%20fresh%20produce%20visible%2C%20warm%20lighting%2C%20commercial%20photography%20style&width=300&height=200&seq=store2&orientation=landscape'
    },
    {
      id: 3,
      name: 'بقالة الحي',
      distance: '1.2 كم',
      rating: 4.5,
      image: 'https://readdy.ai/api/search-image?query=Neighborhood%20grocery%20store%20in%20Saudi%20Arabia%2C%20traditional%20yet%20modern%2C%20clean%20exterior%2C%20fresh%20food%20displays%2C%20welcoming%20atmosphere&width=300&height=200&seq=store3&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* الهيدر */}
      <div className="bg-green-500 pt-12 pb-6 px-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <i className="ri-map-pin-fill text-white text-lg ml-2"></i>
            <span className="text-white text-sm">الرياض، حي النخيل</span>
          </div>
          <button onClick={() => navigate('/profile')} className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-user-fill text-white"></i>
          </button>
        </div>

        {/* شريط البحث */}
        <div className="relative">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="ابحث عن منتج أو متجر..."
            className="w-full px-4 py-3 pr-12 rounded-lg text-right border-none focus:ring-2 focus:ring-white/50"
          />
          <i className="ri-search-line absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
        </div>
      </div>

      {/* الأقسام */}
      <div className="px-6 py-6">
        <h2 className="text-lg font-bold text-gray-800 mb-4">تصفح الأقسام</h2>
        <div className="grid grid-cols-3 gap-4">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => navigate(`/store/1`)}
              className="flex flex-col items-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
            >
              <div className={`w-12 h-12 ${category.color} rounded-full flex items-center justify-center mb-2`}>
                <i className={`${category.icon} text-xl text-gray-600`}></i>
              </div>
              <span className="text-xs text-gray-700 text-center leading-tight">{category.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* المتاجر القريبة */}
      <div className="px-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-gray-800">المتاجر القريبة</h2>
          <button className="text-green-500 text-sm font-medium">عرض الكل</button>
        </div>

        <div className="space-y-4">
          {nearbyStores.map((store) => (
            <div key={store.id} className="bg-white rounded-lg shadow-sm overflow-hidden">
              <img
                src={store.image}
                alt={store.name}
                className="w-full h-32 object-cover"
              />
              <div className="p-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-medium text-gray-800">{store.name}</h3>
                  <div className="flex items-center">
                    <i className="ri-star-fill text-yellow-400 text-sm ml-1"></i>
                    <span className="text-sm text-gray-600">{store.rating}</span>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500 flex items-center">
                    <i className="ri-map-pin-line text-xs ml-1"></i>
                    {store.distance}
                  </span>
                  <button
                    onClick={() => navigate(`/store/${store.id}`)}
                    className="bg-green-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-green-600 transition-colors"
                  >
                    ابدأ التسوق
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* شريط التنقل السفلي */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
        <div className="grid grid-cols-4 h-16">
          <button className="flex flex-col items-center justify-center text-green-500">
            <i className="ri-home-fill text-xl mb-1"></i>
            <span className="text-xs">الرئيسية</span>
          </button>
          <button className="flex flex-col items-center justify-center text-gray-400">
            <i className="ri-search-line text-xl mb-1"></i>
            <span className="text-xs">البحث</span>
          </button>
          <button 
            onClick={() => navigate('/cart')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-shopping-cart-line text-xl mb-1"></i>
            <span className="text-xs">السلة</span>
          </button>
          <button 
            onClick={() => navigate('/profile')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-user-line text-xl mb-1"></i>
            <span className="text-xs">حسابي</span>
          </button>
        </div>
      </div>
    </div>
  );
}
